module.exports = __webpack_public_path__ + "img/Abnormal.28ab561a.png";